import { empty, notUndefinedAndNull } from "../utils/Validation";

export function getSession() {

  var session = null;
  session = sessionStorage.userObj;
  if(!empty(session)){ 
    return JSON.parse(session);
  }else{
    return null;
  }
}

export function createSession(data) {
  if (notUndefinedAndNull(data)) {
    sessionStorage.userObj = JSON.stringify(data);
  } 
}

//return token
export function getToken(){

  let session = getSession();
    if (!empty(session)) {
        return session.token;
    }
}

//create and get form url identifier session

export function createFormSession(urlIdentifier){
  if (!empty(urlIdentifier)) {
    sessionStorage.urlIdentifier = urlIdentifier;
  } 
}

export function getFormSession(){
  if (!empty(sessionStorage.urlIdentifier)) {
      return sessionStorage.urlIdentifier;
  }
}

export function clearSession() {
  sessionStorage.removeItem("userObj");
  localStorage.clear()
  sessionStorage.clear();
}